import { summaryActionTypes } from '../../constants/actionTypes/ssapActionTypes';

export const INITIAL_STATE = {
    areOnlyUpdatedFieldsShown: false,
    isExtraFinalSummaryShown: false,
    isSummaryCrashed: false
};

export default (state = INITIAL_STATE, action = {}) => {
    switch(action.type) {
        case summaryActionTypes.TOGGLE_UPDATED_VALUES_VISIBILITY:
            return {
                ...state,
                areOnlyUpdatedFieldsShown: action.areVisible
            };
        case summaryActionTypes.SHOW_EXTRA_FINAL_SUMMARY:
            return {
                ...state,
                isExtraFinalSummaryShown: action.isShown
            };
        case summaryActionTypes.SET_SUMMARY_CRASHED:
            return {
                ...state,
                isSummaryCrashed: true
            };
        case summaryActionTypes.CLEAR_SUMMARY_VALUES:
            return {
                ...INITIAL_STATE,
                isExtraFinalSummaryShown: state.isExtraFinalSummaryShown
            };
        case summaryActionTypes.CLEAR_SSAP_STATE:
            return INITIAL_STATE;
        default:
            return state;
    }
};

// Selectors

export const selectIfOnlyUpdatedFieldsShown = state => state.areOnlyUpdatedFieldsShown;
export const selectIfExtraFinalSummaryShown = state => state.isExtraFinalSummaryShown;
export const selectIfSummaryCrashed = state => state.isSummaryCrashed;